'use strict';


import { EnvironmentLayer } from './EnvironmentLayer';
import { Loader } from '../../../threejs/loader/Loader';
import { Mesh, RepeatWrapping } from 'three';
import { prepareMaterial } from '../../../threejs/autoProjectScript';
import { log } from 'three/examples/jsm/nodes/math/MathNode';

export class SeaEnvironment extends EnvironmentLayer{
	constructor () {
		super('Sea');
		this.material = null;
	}
	
	show() {
		this.group.visible = true;
	}
	
	hide() {
		this.group.visible = false;
	}
	
	loadFromBundle (scene, conf) {
		const configData = conf[this.id];
		if (!configData) return;
		
		this.settings = configData.settings;
		const mesh = scene.getObjectByName('Sea');
		if (!mesh) return;
		
		const loader = new Loader();
		const textureLoader = loader.textureLoader;
		const noise = textureLoader.load(`${config.cdnRepository}/DreamsGeneralStorage/textures/water/noise.jpg`);
		noise.wrapS = noise.wrapT = RepeatWrapping;
		let defaultWaterTexture = null;
		const materialConfig = configData.material.config;
		if (materialConfig.map === 'water.jpg') {
			materialConfig.map = null;
			defaultWaterTexture = textureLoader.load(`${config.cdnRepository}/DreamsGeneralStorage/textures/water/water.jpg`);
			defaultWaterTexture.wrapS = defaultWaterTexture.wrapT = RepeatWrapping;
		}
		
		this.material = prepareMaterial(materialConfig,textureLoader,'SeaMaterial');
		this.material.noise = noise;
		
		if (defaultWaterTexture) {
			this.material.map = defaultWaterTexture;
		}
		
		const seaMesh = new Mesh(mesh.geometry.clone(),this.material);
		seaMesh.name = 'Sea';
		this.group.add(seaMesh);
	}
	
	setDayTime(times) {
		if (this.material) {
			this.material.setDayTime(times);
		}
	}
	
	setTime(time) {
		if (this.material) {
			this.material.setTime(time);
		}
	}
	
	set settings(data) {
		if (data) {
			this.group.position.fromArray(data.position);
			
			if (data.rotation) {
				this.group.rotation.fromArray(data.rotation);
			}
			
			if (data.scale) {
				this.group.scale.fromArray(data.scale);
			}
		}
	}
	
}
